import { createContext, useEffect, useRef, useState } from "react";
import api from "./api";
import * as C from "./crypto";

export const LearnCtx = createContext(null);
export const REACTIONS = [["loved", "Loved it"], ["helpful", "Helpful"], ["unclear", "Unclear"], ["too_fast", "Too fast"], ["too_slow", "Too slow"]];
export const LEVELS = [["", "No level"], ["beginner", "Beginner"], ["intermediate", "Intermediate"], ["advanced", "Advanced"], ["all", "All levels"]];
export const levelLabel = (v) => (LEVELS.find(([k]) => k === v) || [])[1] || "";

// A student's progress in one Beacon: completed lessons, last opened, name sharing and feedback sent.
export const useLearn = (bid, enabled, encKey) => {
  const [s, setS] = useState({ done: new Set(), last: null, share: false, feedback: {} });
  useEffect(() => {
    if (!enabled || !bid) return;
    api.get(`/beacon/${bid}/progress`).then(({ data }) => setS({ done: new Set(data.done), last: data.last_item, share: data.share_name, feedback: data.feedback || {} })).catch(() => {});
  }, [bid, enabled]);
  if (!enabled) return null;
  const mark = (iid, done) => {
    setS((p) => { const d = new Set(p.done); if (done) d.add(iid); else d.delete(iid); return { ...p, done: d, last: iid }; });
    api.post(`/beacon/${bid}/progress`, { item_id: iid, done }).catch(() => {});
  };
  const opened = (iid) => { if (s.last === iid) return; setS((p) => ({ ...p, last: iid })); api.post(`/beacon/${bid}/progress`, { item_id: iid }).catch(() => {}); };
  const setShare = (share) => { setS((p) => ({ ...p, share })); api.put(`/beacon/${bid}/progress/share`, { share }).catch(() => {}); };
  const sendFeedback = async (iid, reaction, note, anon) => {
    const body = { item_id: iid, reaction, anon };
    if (note) {
      if (encKey) { const e = await C.encryptText(encKey, note); body.note = e.ctB64; body.note_iv = e.ivB64; } else body.note = note;
    }
    await api.post(`/beacon/${bid}/feedback`, body);
    setS((p) => ({ ...p, feedback: { ...p.feedback, [iid]: reaction || "note" } }));
  };
  return { ...s, mark, opened, setShare, sendFeedback };
};

// Video lessons resume where the student left off (saved on this device) and complete at 90%.
export const useVideoProgress = (it, learn) => {
  const lastSave = useRef(0);
  if (it.type !== "video") return {};
  const key = `ss_vpos_${it.id}`;
  return {
    onLoadedMetadataCapture: (e) => {
      const v = e.target; if (v.tagName !== "VIDEO") return;
      const p = parseFloat(localStorage.getItem(key) || "0");
      if (p > 5 && v.duration && p < v.duration - 10) v.currentTime = p;
    },
    onTimeUpdateCapture: (e) => {
      const v = e.target; if (v.tagName !== "VIDEO" || !v.duration) return;
      if (Math.abs(v.currentTime - lastSave.current) > 5) { lastSave.current = v.currentTime; localStorage.setItem(key, String(v.currentTime)); }
      if (learn && !learn.done.has(it.id) && v.currentTime / v.duration > 0.9) learn.mark(it.id, true);
    },
  };
};
